import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

const adminApi = axios.create({ baseURL: ADMIN_API });

export const setAdminToken = (t) => {
  if (t) localStorage.setItem("ast", t);
  else localStorage.removeItem("ast");
};
export const getAdminToken = () => localStorage.getItem("ast");

adminApi.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers["X-Admin-Auth"] = t;
    cfg.headers["Authorization"] = `Bearer ${t}`;
  }
  return cfg;
});

export default adminApi;
